import React, {ReactNode, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';

import OktaAuth, {toRelativeUrl} from '@okta/okta-auth-js';
import {Security} from '@okta/okta-react';
import {AuthenticationConfig, CALLBACK_PATH} from 'src/modules/authentication/okta-provider/typedefs';

import {OktaAuthenticationController} from './okta-authentication-controller';

type Props = {
    authConfig: AuthenticationConfig,
    children: ReactNode,
};

export const OktaAuthenticationEnvironment = ({children, authConfig}: Props) => {
    const navigate = useNavigate();

    const oktaAuth = useMemo<OktaAuth>(() => new OktaAuth({
        issuer: authConfig.config.url,
        clientId: authConfig.config.clientId,
        redirectUri: window.location.origin + CALLBACK_PATH,
        scopes: ['openid', 'profile', 'email'],
        tokenManager: {
            autoRenew: true,
        },
    }), [authConfig]);

    const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
        const relativeUrl = toRelativeUrl(originalUri || '/', window.location.origin);
        navigate(relativeUrl);
    };

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <OktaAuthenticationController>
                {children}
            </OktaAuthenticationController>
        </Security>
    );
};
